<div class="grid mb-4">
    <div class="col-3 input-field">
        <label for="workerId">Operario</label>
        <p-dropdown [options]="workers" [(ngModel)]="filters.workerId" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operador"
            (onChange)="search()"></p-dropdown>
    </div>
    <div class="col-3 input-field">
        <label for="workerId">Sociedad</label>
        <p-dropdown [options]="business" [(ngModel)]="filters.businessId" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona una sociedad"
            (onChange)="search()"></p-dropdown>
    </div>
    <div class="col-2 input-field">
        <label for="dateStart">Desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()"></p-calendar>
    </div>
    <div class="col-2 input-field">
        <label for="dateEnd">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()"></p-calendar>
    </div>
    <div class="col flex" style="align-items: center;">
        <p-button label="Limpiar filtros" (click)="clearFilters()" class="mt-3" />
    </div>
</div>
<p-accordion [multiple]="true">
    <p-accordionTab *ngFor="let workerBusiness of workersBusiness">
        <ng-template pTemplate="header">
            <div class="grid align-items-center" style="width: 100%;">
                <div class="col-1">
                    <p-checkbox *ngIf="workerBusiness.workerVat!=null && workerBusiness.workerVat != ''"
                        [binary]="true" [(ngModel)]="selectedWorkers[workerBusiness.id]"
                        (onChange)="toggleAllCases(workerBusiness.id, $event.checked)"
                        (click)="$event.stopPropagation()">
                    </p-checkbox>
                </div>
                <div class="col-2">
                    <span>{{workerBusiness.workerName}}</span>                    
                    <span
                    *ngIf="workerBusiness.workerVat!=null && workerBusiness.workerVat != ''"> ({{workerBusiness.workerVat}})</span>
                    <p-tag *ngIf="!(workerBusiness.workerVat!=null && workerBusiness.workerVat != '')" severity="danger"
                        value="No tiene CIF/NIF registrado"></p-tag>
                </div>
                <div class="col-3">                    
                    <span>{{workerBusiness.businessName}}</span>
                </div>                   
                <div class="col-2">
                    <span>Subtotal: {{ getSubtotalSelected(workerBusiness.id) | currency: 'EUR' }}</span>
                </div>
                <div class="col-2">
                    <span>Impuestos: {{ getTaxAmountSelected(workerBusiness.id) | currency: 'EUR' }}</span>
                </div>
                <div class="col-2">
                    <span>Total: {{ getTotalSelected(workerBusiness.id) | currency: 'EUR' }}</span>
                </div>
            </div>
        </ng-template>
        <p-table #grid [value]="workerBusiness.billableItems" [scrollable]="true" scrollHeight="flex"
            [(selection)]="selectedWorkerBusiness[workerBusiness.id]" dataKey="id"
            (selectionChange)="updateHeaderCheckboxState(workerBusiness.id)">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSelectableColumn *ngIf="workerBusiness.workerVat!=null && workerBusiness.workerVat != ''"></th>
                    <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon></th>
                    <th style="text-align: right;">Cantidad</th>
                    <th style="text-align: right;">Precio</th>
                    <th style="text-align: right;">Impuestos</th>
                    <th style="text-align: right;">Total</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-billableItem let-columns="columns">
                <tr>
                    <td *ngIf="workerBusiness.workerVat!=null && workerBusiness.workerVat != ''">
                        <p-tableCheckbox 
                            [value]="billableItem"></p-tableCheckbox>
                    </td>
                    <td>{{billableItem.description}}</td>
                    <td style="text-align: right;">
                        {{billableItem.quantity}}
                    </td>
                    <td style="text-align: right;">
                        {{billableItem.price | currency: 'EUR'}}
                    </td>
                    <td style="text-align: right;">                            
                        {{'('+billableItem.taxName+')'}} {{billableItem.taxAmount | currency: 'EUR' }}
                    </td>
                    <td style="text-align: right;">
                        {{getTotalBillableItem(billableItem) | currency: 'EUR' }}
                    </td>   
                </tr>
            </ng-template>
        </p-table>
    </p-accordionTab>
</p-accordion>
<!--<p-card *ngFor="let caseService of jobsCaseServices" [header]="caseService.name" styleClass="mt-4">
    <div class="p-1">-->

<!--</div>    
</p-card>-->
<div class="mt-4 flex gap-2 justify-content-end">
    <div style="text-align: right;">
        <h3><b>Subtotal:</b> {{ getSubtotalSelected(null) | currency: 'EUR' }}</h3>
        <h3><b>Impuestos:</b> {{ getTaxAmountSelected(null) | currency: 'EUR' }}</h3>
        <!--<h3><b>Impuestos:</b> {{ getTaxSelected() | currency: 'EUR' }}</h3>-->
        <h2><b>Total:</b> {{ getTotalSelected(null) | currency: 'EUR' }}</h2>
    </div>
</div>
<div class="mt-4 flex gap-2 justify-content-end">
    <p-button label="Generar factura" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
        (click)="showModal()"></p-button>
</div>
<span *ngIf="workersBusiness.length == 0">
    No se han encontrado expedientes a facturar
</span>

<p-dialog header="Selecciona una fecha de factura" [(visible)]="displayModal" [modal]="true" [closable]="false"
    [style]="{width: '300px'}">
    <div class="input-field">
        <label for="date">Fecha</label>
        <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="selectedDate" [showIcon]="true" [showButtonBar]="true"
            [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error
            appendTo="body"></p-calendar>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Guardar" icon="pi pi-check" (click)="save()"></button>
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="hideModal()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>